export const noRecordsFound = () => 'No Record found.';
export const noResultsFound = () => 'No Results found.';
export const duplicateFileError = () =>
  'A file with the same file name or file content is already uploaded to this submission. Please upload a new file.';
